import React from 'react';
import { getCookie } from '../utils/cookie';

const CSRFToken = () => <input type="hidden" name="csrfmiddlewaretoken" value={getCookie('csrftoken')} />;

export default CSRFToken;



// WEBPACK FOOTER //
// ./src/components/CSRFToken.js